// @ts-nocheck
// Adapter widget for the dashboard grid: reads shared graphData + loading +
// refresh handler from DashboardDataContext.
import AgentStatusDistribution from './AgentStatusDistribution';
import { useDashboardData } from '../DashboardDataContext';

export default function AgentStatusDistributionWidget() {
  const d = useDashboardData();
  return (
    <AgentStatusDistribution
      graphData={d.graphData}
      loading={d.loadingForAgentStatusDistribution}
      onRefresh={d.refreshAgentStatusDistribution}
    />
  );
}
